import { api } from '@/services'

export function list() {
  return api.get('/admin/appointment/serviceTypes')
}